import * as Yup from 'yup';

export const createSchema = Yup.object({
  id: Yup.string().trim().required('Demo ID is required'),
  title: Yup.string().trim().required('Title is required'),
  url: Yup.string().trim().url('Must be a valid URL').required('Demo URL is required'),
  description: Yup.string(),
});

export const editSchema = Yup.object({
  title: Yup.string().trim().required('Title is required'),
  url: Yup.string().trim().url('Must be a valid URL').required('Demo URL is required'),
  description: Yup.string(),
});
